import TextField from "@/components/common/text-field/TextField.vue";
import Contacts from "@/components/company/contacts/Contacts.vue";
import Pagination from "@/components/common/table-field/Pagination.vue";

export default {
    name: 'Company',
    components: {
        Pagination,
        Contacts,
        TextField
    },

    data() {
        return {
            loading: false,
            list: [],
            params: {
                pageSize: 20,
                search: null,
                page: 1,
            },
            links: [],
            controller: null,
            expanded: [],
        }
    },

    computed: {
        totalPages() {
            return this.params.last_page || 1;
        },

        visiblePages() {
            const total = this.totalPages;
            const current = this.params.page;
            const maxVisible = 5;
            let start = Math.max(current - 2, 1);
            let end = Math.min(start + maxVisible - 1, total);
            start = Math.max(end - maxVisible + 1, 1);

            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        },
    },

    methods: {
        async populateData() {
            this.loading = true;
            this.expanded = [];

            if (sessionStorage.getItem("company_params_search") != null) {
                this.params.search = sessionStorage.getItem("company_params_search");
            }

            try {
                const response = await this.ApiRequest.requestAsync(
                    `company/list`,
                    this.ApiRequest.REQUEST_POST,
                    this.params,
                    'company-list',
                    true
                );

                if (!response || response.error || response.canceled) return;
                const { data, pagination } = response;
                this.list = this.BasicHelper.cloneObject(data.company);
                this.params = {
                    ...this.params,
                    ...pagination
                }
            } finally {
                this.loading = false;
            }
        },

        toggle(id) {
            this.expanded[id] = !this.expanded[id];
        },

        changePage(number) {
            if (number < 1 || number > this.totalPages) return;
            this.params.page = number;
            this.populateData();
        }
    },

    beforeMount() {
        this.populateData();
    },

    watch: {
        'params.search'() {
            if (this.params.search != '' && this.params.search != null) {
                sessionStorage.setItem('company_params_search', this.params.search);
            } else {
                sessionStorage.removeItem("company_params_search");
            }
            this.populateData();
        }
    }
}
